import React from 'react';
import styled from 'styled-components';
import { RadiusOption } from 'types/graphql';
import { radius } from 'shared/constants/customization';

type RadiusStyle = {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  tags: string;
  cards: string;
  buttons: string;
};

const Rounded = styled.div`
  border: 2px solid #4f5d68;
  border-radius: 50%;
  height: 16px;
  width: 16px;
`;

const RoundedRectangle = styled.div`
  border: 2px solid #4f5d68;
  border-radius: 4px;
  height: 16px;
  width: 16px;
`;

const Square = styled.div`
  border: 2px solid #4f5d68;
  height: 16px;
  width: 16px;
`;

const adminRadiusOptions = {
  [RadiusOption.rounded]: {
    description: 'Buttons and other elements have fully rounded corners.',
    icon: <Rounded />,
  },
  [RadiusOption.roundedRectangle]: {
    description: 'Buttons and majority of elements have slightly rounded corners.',
    icon: <RoundedRectangle />,
  },
  [RadiusOption.square]: {
    description: 'Buttons and majority of elements have sharp corners.',
    icon: <Square />,
  },
};

export const radiusOptions = radius.map((option) => ({
  ...option,
  ...adminRadiusOptions[option.value],
}));

// Never returns null: every consumer of the preview theme (categories-list.tsx, product cards,
// etc.) reads theme.radius.<key> unconditionally, assuming a style always resolves. Previously
// an unrecognized/missing `option` (e.g. a dispensary with no saved radius, or a form field with
// no mounted <Controller> — see use-theme-form.ts's onSubmit) produced `null` here, which crashed
// with "Cannot read properties of null (reading 'buttons')" the first time anything read a key
// off it.
// `radius[0]` is the "Rounded" entry (RadiusOption.rounded) — always present, so it's a safe
// fallback without a non-null assertion on the `.find()` result.
const DEFAULT_RADIUS_STYLE: RadiusStyle = radius[0].style;

export const getRadiusStyle = (option: RadiusOption | null | undefined): RadiusStyle =>
  radius.find(({ value }) => value === option)?.style ?? DEFAULT_RADIUS_STYLE;
